// extracted by mini-css-extract-plugin
export var excerpt = "SearchHitContact-module--excerpt--oKaSg";
export var image = "SearchHitContact-module--image--qA87P";
export var meta = "SearchHitContact-module--meta--KWsmC";
export var teaser = "SearchHitContact-module--teaser---+9t+";
export var teaserHeader = "SearchHitContact-module--teaserHeader--gC29g";
export var teaserWImage = "SearchHitContact-module--teaserWImage--C2AUS";
export var title = "SearchHitContact-module--title--H+s0g";
export var titleLink = "SearchHitContact-module--titleLink--jq3uW";